import PropTypes from 'prop-types'
import { customerContactDepartmentPropType } from './customer-contact-department-prop-type'

const CONTACT_TYPES = {
    CUSTOMER_CONTACT: 'CUSTOMER_CONTACT',
    FLEET_CONTACT: 'FLEET_CONTACT'
}

/**
 * @typedef {Object} customerContactPropType
 * @property {string}                                   [contactType]               - The type of the contact
 * @property {string}                                   [currentEmailAddress]       - Current email address of contact
 * @property {array<customerContactDepartmentPropType>} [departments]               - Company departments the contact works in
 * @property {string}                                   [id]                        - The identifier of the contact
 * @property {string}                                   [languageCode]              - Code for the language of the contact
 * @property {string}                                   [locale]                    - The locale of the contact
 * @property {string}                                   [name]                      - The name of the contact
 * @property {string}                                   [phone]                     - The phone number of the contact
 * @property {string}                                   [position]                  - The identifier for the position of the contact in the company
 * @property {string}                                   [positionFreeText]          - Free-text field for the position of the contact in the company
 * @property {string}                                   [positionStringCode]        - String code to translate the contacts position in the company
 * @property {string}                                   [unconfirmedEmailAddress]   - Contacts email address that has not been confirmed yet
 */
export const customerContactPropType = PropTypes.shape({
    contactType: PropTypes.oneOf(Object.values(CONTACT_TYPES)),
    currentEmailAddress: PropTypes.string,
    departments: PropTypes.arrayOf(customerContactDepartmentPropType),
    id: PropTypes.string,
    languageCode: PropTypes.string,
    locale: PropTypes.string,
    name: PropTypes.string,
    phone: PropTypes.string,
    position: PropTypes.string,
    positionFreeText: PropTypes.string,
    positionStringCode: PropTypes.string,
    unconfirmedEmailAddress: PropTypes.string
})
